
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

import Lottery from '@/components/Lottery.vue'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    components: {
        Lottery,
    },
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const isApp = ref<boolean>(false)
        const list = ref<any[]>([])
        const lotteryShow = ref<boolean>(false)

        const getList = () => {
            _this.proxy.$http('/wap/wapTopic/topicDynamic', {
                topic_ids: [$store.state.topicData.id],
                page_size: 100
            }).then((data) => {
                let dynamicList = data.dynamic || []
                let newList:any[] = []
                let len = dynamicList.length
                for (let j = 0; j < 4; j++) {
                    newList[j] = []
                    for (let i = 0; i < len; i++) {
                        if (i % 4 == j) {
                            let content = dynamicList[i].content.replace(/<(?:.|\s)*?>/g, '').replace(/[\n\r]/g, '').replace(/↵/g, '')
                            dynamicList[i].content = COVER.renderReplyContent(content)
                            dynamicList[i].nick_name = encryption(dynamicList[i].nick_name)
                            newList[j].push(dynamicList[i])
                        }
                    }
                }
                list.value = JSON.parse(JSON.stringify(newList))
                nextTick(() => {
                    setListStyle()
                })
            })
        }

        const encryption = (name: string) => {
            if (name.length > 2) {
                name = `${name.slice(0, 1)}${name.length > 3 ? '**' : '*'}${name.slice(name.length - 1, name.length)}`
            } else if (name.length == 2) {
                name = name.slice(0, 1) + '*'
            } else {
                name = '*'
            }
            return name
        }

        const setListStyle = () => {
            let listDom = document.querySelectorAll('.barrage-list')
            let wrapW = (document.querySelector('.wall') as HTMLDivElement).getBoundingClientRect().width
            for(let i = 0; i < 4; i++) {
                let item = listDom[i].querySelectorAll('.barrage-item')
                let itemLen = item.length
                let listW = 0
                for(let itemI = 0; itemI < itemLen; itemI++) {					
                    listW += item[itemI].getBoundingClientRect().width + Math.ceil(parseFloat(window.getComputedStyle(item[itemI],null).marginRight))
                }
                listW += wrapW
                let time = Math.ceil(listW / wrapW) * 2
                let style =`width: ${listW}px;-webkit-animation: dynamicMove ${time}s linear infinite;-animation: dynamicMove ${time}s linear infinite`
                listDom[i].setAttribute('style', style)
			}

        }

        const defaultUser = (img: string) => {
            return COVER.defaultUser(img)
        }

        const goRule = () => {
            $router.push('/rule')
        }

        const goRecord = () => {
            if (!isApp.value) {
                $store.commit('SET_DIALOGDATA', {
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '取消',
                            className : 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className : 'download-btn'
                        }
                    ]
                })
                return
            }
            if (!$store.state.userInfo.token) {
                $store.commit('SET_DIALOGDATA', {
                    text: '请先登录~',
                    btns: [
                        {
                            text: '取消',
                            className : 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className : 'login-btn'
                        }
                    ]
                })
                return
            }
            $router.push('/record')
        }

        const goVideoCapture = () => {
            if (!isApp.value) {
                $store.commit('SET_DIALOGDATA', {
                    text: '参加该活动需在封面新闻APP中进行',
                    btns: [
                        {
                            text: '取消',
                            className : 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className : 'download-btn'
                        }
                    ]
                })
                return
            }
            if (COVERAPP.Attribute.appVersion() < 700) {
                $store.commit('SET_DIALOGDATA', {
                    text: '亲，封面app需升级至最新版本，<br>才能参与此活动哦！',
                    btns: [
                        {
                            className: 'update-btn',
                            text: '立即升级'
                        }
                    ]
                })
                return
            }
            if (!$store.state.userInfo.token) {
                $store.commit('SET_DIALOGDATA', {
                    text: '请先登录~',
                    btns: [
                        {
                            text: '取消',
                            className : 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className : 'login-btn'
                        }
                    ]
                })
                return
            }
            if (!$store.state.userInfo.mobile) {
                $store.commit('SET_DIALOGDATA', {
                    text: '请先绑定手机号~',
                    btns: [
                        {
                            text: '取消',
                            className : 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className : 'bindmobile-btn'
                        }
                    ]
                })
                return
            }
            COVERAPP.Method.goVideoCapture({
				topicId: parseInt($store.state.topicData.id),
                topicName: $store.state.topicData.title,
				callback (ret: any) {
                    let data = typeof ret == 'object'.toLowerCase() ? JSON.stringify(ret) : ret
                    if (JSON.parse(data).status == 1) {
                        COVER.track('click', '发布动态成功')
                        lotteryShow.value = true
                    }
				}
			})
        }

        onMounted(() => {
            isApp.value = COVERAPP.Attribute.isApp()
            nextTick(() => {
                isApp.value && COVER.getUser((res: any) => {
                    console.log(res)
                    $store.commit('SET_USERINFO', res)
                })
            })

            getList()

            COVER.track('load', $store.state.activityData.title)

            COVER.onshare($store.state.shareData)

            COVER.pageLoaded()
        })    

        return {
            list,
            lotteryShow,
            goVideoCapture,
            defaultUser,
            goRule,
            goRecord
        }
    }
})
